'use client'

import MainContainer from "@/components/pages/authentication/main-container";
import React from "react";

export default function Layout({
    children
}: {
    children: React.ReactNode
}) {
    return <MainContainer>
        {children}
    </MainContainer>
};